import { useState, useEffect } from 'react';

var mobileBp = 768;
var tabletBp = 992;
var BREAKPOINTS = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop'
};
function getBreakpoint() {
  if (typeof window === 'undefined') {
    return undefined;
  }
  var deviceSize = window.innerWidth;
  if (deviceSize < mobileBp) {
    return BREAKPOINTS.MOBILE;
  }
  if (deviceSize < tabletBp) {
    return BREAKPOINTS.TABLET;
  }
  return BREAKPOINTS.DESKTOP;
}
var useBreakpoint = () => {
  var [breakpoint, setBreakpoint] = useState(getBreakpoint());
  useEffect(() => {
    var handleResize = () => setBreakpoint(getBreakpoint());
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return breakpoint;
};
var constructSizes = breakpoints => {
  var defaultSlotSize = breakpoints.find(bp => !bp.breakpoint) && breakpoints.find(bp => !bp.breakpoint).slotSize;
  var validatedBreakpointsWithoutDefault = breakpoints.filter(bp => !!bp.breakpoint && bp.breakpoint.includes('px'));
  return validatedBreakpointsWithoutDefault.sort((a, b) => b.breakpoint.split('px')[0] - a.breakpoint.split('px')[0]).reduce((acc, _ref) => {
    var {
      breakpoint,
      slotSize
    } = _ref;
    return [...acc, "(min-width: ".concat(breakpoint, ") ").concat(slotSize)];
  }, []).concat(defaultSlotSize || []).join(', ');
};

export { BREAKPOINTS, constructSizes, getBreakpoint, useBreakpoint };
//# sourceMappingURL=index.js.map
